import SEO from './composants/SEO';
import { SEO_PAGES } from './donnees/seoPages'; 
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { supabase } from './supabaseClient';
import { appelAPI, telechargerFichier } from './api';
import './TableauDeBord.css';
import LogoPefep from './LogoPefep';

// ══════════════════════════════════════════════════════════════
// PEFEP Site — TABLEAU DE BORD v2.1
// - Quota affiché et respecté (client simple / dev / admin)
// - Bouton principal qui bascule vers le paiement quand bloqué
// - Téléchargement du site, verrouillé tant que non réglé
// ══════════════════════════════════════════════════════════════

// Statuts autorisant le téléchargement — doit rester aligné
// avec STATUTS_REGLES dans backend/securite.js
const STATUTS_TELECHARGEABLES = ['paye', 'publie'];

const STATUTS_INFO = {
  brouillon:       { label: 'Brouillon',           couleur: '#F59E0B', icone: '📝' },
  paye_en_attente: { label: 'Paiement en attente', couleur: '#F97316', icone: '⏳' },
  paye:            { label: 'Payé',                couleur: '#00A651', icone: '💚' },
  publie:          { label: 'Publié',              couleur: '#10B981', icone: '✅' },
  archive:         { label: 'Archivé',             couleur: '#94A3B8', icone: '📦' },
};

const SECTEURS_ICONES = {
  eglise: '⛪', restaurant: '🍽️', ong: '🤝', coach: '🎯',
  boutique: '🛍️', ecole: '🎓', salon: '💅', blog: '✍️',
  immobilier: '🏠', freelance: '💼', liberal: '⚕️',
};

// ══════════════════════════════════════════════════════════════
// COMPOSANT PRINCIPAL
// ══════════════════════════════════════════════════════════════
// ══════════════════════════════════════════════════════════════
// BARRE LATÉRALE — AUTRES SERVICES PEFEP
// ══════════════════════════════════════════════════════════════
// Vitrine des autres services de l'écosystème. Barre latérale
// gauche sur PC, bloc empilé sur mobile. Le bouton « Parlez à un
// expert » ouvre une modale de prise de contact simple.
// ══════════════════════════════════════════════════════════════
function BarreServices({ user }) {
  const [modaleOuverte, setModaleOuverte] = useState(false);
  const [envoye, setEnvoye] = useState(false);
  const [erreur, setErreur] = useState('');
  const [form, setForm] = useState({ nom: '', numero: '', nature: '', requete: '' });

  const nomPreRempli = user?.nom || '';

  const ouvrirService = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const changer = (champ, valeur) => {
    setForm(prev => ({ ...prev, [champ]: valeur }));
  };

  const envoyerExpert = () => {
    const nom = form.nom || nomPreRempli;
    if (!nom || !form.numero) {
      setErreur('Merci d\'indiquer votre nom et votre numéro.');
      return;
    }
    if (!form.nature) {
      setErreur('Merci de préciser la nature de votre demande.');
      return;
    }
    setErreur('');

    const lignes = [
      'Bonjour PEFEP, je souhaite parler à un expert.',
      '',
      'Nom : ' + nom,
      'Numéro : ' + form.numero,
      'Nature : ' + form.nature,
    ];
    if (form.requete) {
      lignes.push('');
      lignes.push('Ma demande : ' + form.requete);
    }
    const message = encodeURIComponent(lignes.join(String.fromCharCode(10)));
    window.open('https://wa.me/50947376200?text=' + message, '_blank', 'noopener,noreferrer');
    setEnvoye(true);
  };

  return (
    <aside className="tdb-services">
      <div className="tdb-services-titre">🚀 Découvrez nos autres services PEFEP</div>

      <div className="tdb-service-carte" onClick={() => ouvrirService('https://pefepacademie.com/')}>
        <div className="tdb-service-icone">🎓</div>
        <div className="tdb-service-nom">PEFEP ACADEMIE</div>
        <div className="tdb-service-desc">L'académie du succès — 12 cours disponibles pour développer vos compétences.</div>
        <div className="tdb-service-lien">Visiter →</div>
      </div>

      <div className="tdb-service-carte" onClick={() => ouvrirService('https://pefepgroupe.digital/solutions-digitales/')}>
        <div className="tdb-service-icone">💼</div>
        <div className="tdb-service-nom">PEFEP DIGITAL</div>
        <div className="tdb-service-desc">Marketing digital, SEO, branding, graphic design et accompagnement pour vos projets.</div>
        <div className="tdb-service-lien">Visiter →</div>
      </div>

      <div className="tdb-service-carte tdb-service-expert" onClick={() => setModaleOuverte(true)}>
        <div className="tdb-service-icone">🗣️</div>
        <div className="tdb-service-nom">Parlez à un expert</div>
        <div className="tdb-service-desc">Un besoin précis ? Écrivez-nous, un expert PEFEP vous recontacte.</div>
        <div className="tdb-service-lien">Nous contacter →</div>
      </div>

      <div className="tdb-service-carte tdb-service-bientot">
        <div className="tdb-service-icone">🧾</div>
        <div className="tdb-service-nom">Faktirasyon</div>
        <div className="tdb-service-desc">Votre solution de facturation.</div>
        <div className="tdb-service-badge">Bientôt disponible</div>
      </div>

      {modaleOuverte && (
        <div className="tdb-expert-voile" onClick={() => setModaleOuverte(false)}>
          <div className="tdb-expert-fenetre" onClick={e => e.stopPropagation()}>
            <button type="button" className="tdb-expert-fermer" onClick={() => setModaleOuverte(false)}>×</button>

            <div className="tdb-expert-titre">Parlez à un expert PEFEP</div>

            {envoye ? (
              <div className="tdb-expert-succes">
                ✅ Merci ! WhatsApp s'est ouvert avec votre demande. Envoyez le message pour finaliser — un expert vous répondra rapidement.
              </div>
            ) : (
              <div className="tdb-expert-corps">
                <input
                  className="tdb-expert-champ"
                  type="text" placeholder="Votre nom *"
                  value={form.nom || nomPreRempli}
                  onChange={e => changer('nom', e.target.value)}
                />
                <input
                  className="tdb-expert-champ"
                  type="tel" placeholder="Votre numéro WhatsApp *"
                  value={form.numero}
                  onChange={e => changer('numero', e.target.value)}
                />

                <div className="tdb-expert-label">Nature de votre demande :</div>
                <div className="tdb-expert-natures">
                  {['🔴 Urgent', '🟠 Important', '🔵 Besoin d\'infos'].map(opt => (
                    <button
                      type="button"
                      key={opt}
                      className={`tdb-expert-nature ${form.nature === opt ? 'actif' : ''}`}
                      onClick={() => changer('nature', opt)}
                    >
                      {opt}
                    </button>
                  ))}
                </div>

                <textarea
                  className="tdb-expert-champ"
                  rows={4}
                  placeholder="Décrivez votre demande..."
                  value={form.requete}
                  onChange={e => changer('requete', e.target.value)}
                />

                {erreur && <div className="tdb-expert-erreur">⚠️ {erreur}</div>}

                <button type="button" className="tdb-expert-envoyer" onClick={envoyerExpert}>
                  Envoyer ma demande
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </aside>
  );
}


export default function TableauDeBord() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const [menuOuvert, setMenuOuvert] = useState(false);
  const [chargement, setChargement] = useState(true);
  const [sites, setSites] = useState([]);
  const [quota, setQuota] = useState(null);
  const [quotaCharge, setQuotaCharge] = useState(false);

  const estAdmin = user?.role === 'admin';
  const estDev = user?.type_compte === 'dev';

  // ── Chargement des sites ──
  useEffect(() => {
    const chargerSites = async () => {
      if (!user?.id) return;
      try {
        const { data, error } = await supabase
          .from('sites_generes')
          .select('*')
          .eq('client_id', user.id)
          .order('created_at', { ascending: false });

        if (error) console.error('Erreur chargement sites :', error);
        else setSites(data || []);
      } catch (err) {
        console.error('Exception chargement sites :', err);
      } finally {
        setChargement(false);
      }
    };
    chargerSites();
  }, [user?.id]);

  // ── Chargement du quota ──
  useEffect(() => {
    const chargerQuota = async () => {
      if (!user?.id) return;
      try {
        const { ok, data } = await appelAPI('/api/mon-quota');
        if (ok && data.succes) setQuota(data.quota);
        else console.warn('Quota non chargé :', data?.erreur || 'réponse inattendue');
      } catch (err) {
        console.warn('Quota indisponible :', err.message);
      } finally {
        setQuotaCharge(true);
      }
    };
    chargerQuota();
  }, [user?.id]);

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const nomAffichage = user?.prenom || user?.nom || 'Utilisateur';

  // Quota atteint ? (jamais pour un admin ou un plan illimité)
  const quotaAtteint = Boolean(
    quota && !quota.illimite && quota.restant !== undefined && quota.restant <= 0
  );

  // Tant que le quota n'est pas connu, on n'ouvre pas la création.
  // Un admin n'est jamais concerné : son quota est illimité côté serveur.
 const quotaInconnu = !estAdmin && !quotaCharge;

  // Le site à régler en priorité : le plus ancien non réglé
  const siteARegler = [...sites]
    .reverse()
    .find(s => !STATUTS_TELECHARGEABLES.includes(s.statut) && s.statut !== 'archive');

  const messageMarketing =
    `🚀 DEMANDE MARKETING DIGITAL — PEFEP\n\n` +
    `Bonjour PEFEP GROUPE !\n\n` +
    `Je souhaite en savoir plus sur vos services Marketing Digital (Facebook Ads, Google Ads, TikTok Ads, LinkedIn Ads).\n\n` +
    `👤 Mes informations :\n` +
    `• Nom : ${user?.nom || ''}\n` +
    `• Email : ${user?.email || ''}\n` +
    `• Téléphone : ${user?.telephone || ''}\n\n` +
    `📋 Mon besoin :\n` +
    `[Décrivez brièvement votre projet ici]\n\n` +
    `Merci de me recontacter !`;

  const lienMarketing = `https://wa.me/50947376200?text=${encodeURIComponent(messageMarketing)}`;

  return (
    <div className="tdb-container">
<SEO {...SEO_PAGES.tableauDeBord} />
      {/* ══ NAVBAR ══ */}
      <nav className="tdb-navbar">
        <div className="tdb-navbar-left">
         <LogoPefep lien="/tableau-de-bord" hauteur={38} />
        </div>

        <div className="tdb-navbar-right">
          <button
            type="button"
            className="tdb-btn-demandes"
            onClick={() => navigate('/mes-demandes')}
          >
            📥 Mes demandes
          </button>
          <div className="tdb-user-menu" onClick={() => setMenuOuvert(!menuOuvert)}>
            <div className="tdb-user-avatar">{nomAffichage.charAt(0).toUpperCase()}</div>
            <div className="tdb-user-info">
              <div className="tdb-user-nom">{nomAffichage}</div>
              <div className="tdb-user-type">
                {estAdmin ? '👑 Administrateur' : estDev ? '💼 Compte DEV' : '👤 Client SIMPLE'}
              </div>
            </div>
            <span className="tdb-user-chevron">▼</span>

            {menuOuvert && (
              <div className="tdb-user-dropdown">
                <div className="tdb-dropdown-item tdb-dropdown-info">
                  <strong>{user?.nom} {user?.prenom}</strong>
                  <span>{user?.email}</span>
                </div>
                <div className="tdb-dropdown-separator"></div>

                {estAdmin && (
                  <>
                    <button
                      type="button"
                      className="tdb-dropdown-btn tdb-dropdown-admin"
                      onClick={() => navigate('/admin')}
                    >
                      👑 Espace Administrateur
                    </button>
                    <div className="tdb-dropdown-separator"></div>
                  </>
                )}

                <button type="button" className="tdb-dropdown-btn" onClick={() => navigate('/')}>
                  🏠 Retour à l'accueil
                </button>
                <button type="button" className="tdb-dropdown-btn tdb-dropdown-logout" onClick={handleLogout}>
                  🚪 Se déconnecter
                </button>
              </div>
            )}
          </div>
        </div>
      </nav>

      {/* ══ BIENVENUE ══ */}
      <header className="tdb-header">
        <div className="tdb-header-content">
          <h1>👋 Bonjour {nomAffichage} !</h1>
          <p>Bienvenue dans votre espace PEFEP Site</p>
        </div>
      </header>

      {/* ══ STATISTIQUES ══ */}
      <section className="tdb-stats">
        <div className="tdb-stat-card">
          <div className="tdb-stat-icone">📄</div>
          <div className="tdb-stat-val">{sites.length}</div>
          <div className="tdb-stat-label">Sites créés</div>
        </div>

        <div className="tdb-stat-card">
          <div className="tdb-stat-icone">✅</div>
          <div className="tdb-stat-val">{sites.filter(s => s.statut === 'publie').length}</div>
          <div className="tdb-stat-label">Sites publiés</div>
        </div>

        <div className="tdb-stat-card">
          <div className="tdb-stat-icone">⏳</div>
          <div className="tdb-stat-val">
            {sites.filter(s => s.statut === 'brouillon' || s.statut === 'paye_en_attente').length}
          </div>
          <div className="tdb-stat-label">En attente</div>
        </div>

        <div className="tdb-stat-card tdb-stat-card-highlight">
          <div className="tdb-stat-icone">🎁</div>
          <div className="tdb-stat-val tdb-stat-code">{user?.code_parrainage || '—'}</div>
          <div className="tdb-stat-label">Votre code parrainage</div>
        </div>
      </section>

      {/* ══ CONTENU PRINCIPAL ══ */}
      <main className="tdb-main">
        <div className="tdb-layout">
          <div className="tdb-colonne-principale">
            {estDev ? (
              <ContenuDev
                sites={sites}
                chargement={chargement}
                quota={quota}
                quotaAtteint={quotaAtteint}
                quotaInconnu={quotaInconnu}
                siteARegler={siteARegler}
                user={user}
              />
            ) : (
              <ContenuSimple
                sites={sites}
                chargement={chargement}
                quota={quota}
                quotaAtteint={quotaAtteint}
                quotaInconnu={quotaInconnu}
                siteARegler={siteARegler}
              />
            )}
          </div>

          <BarreServices user={user} />
        </div>
      </main>

      

      {/* ══ PIED DE PAGE ══ */}
      <footer className="tdb-footer">
        <div className="tdb-footer-content">
          <div className="tdb-footer-logo">PEFEP</div>
          <p>Là où vos idées rencontrent la tech</p>
          <p className="tdb-footer-mention">🇭🇹 Made in Haïti — © 2026 PEFEP GROUPE</p>
        </div>
      </footer>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════
// BOUTON PRINCIPAL — bascule création / paiement selon le quota
// ══════════════════════════════════════════════════════════════
function BoutonPrincipal({ quotaAtteint, quotaInconnu, siteARegler, libelleCreer }) {
  const navigate = useNavigate();

  // Le quota n'est pas encore connu : on verrouille par prudence
  if (quotaInconnu) {
    return (
      <button
        type="button"
        className="tdb-btn-creer tdb-btn-attente"
        disabled
        title="Vérification de votre espace en cours"
      >
        ⏳ Vérification…
      </button>
    );
  }

  if (quotaAtteint && siteARegler) {
    return (
      <button
        type="button"
        className="tdb-btn-creer tdb-btn-regler"
        onClick={() => navigate(`/mes-sites/${siteARegler.id}?scroll=paiement`)}
      >
        💳 Régler mon site
      </button>
    );
  }

  return (
    <button
      type="button"
      className="tdb-btn-creer"
      onClick={() => navigate('/creer-mon-site')}
    >
      {libelleCreer}
    </button>
  );
}

// ══════════════════════════════════════════════════════════════
// CONTENU — CLIENT SIMPLE
// ══════════════════════════════════════════════════════════════
function ContenuSimple({ sites, chargement, quota, quotaAtteint, quotaInconnu, siteARegler }) {
  const navigate = useNavigate();

  return (
    <div className="tdb-contenu-simple">

      {/* ── Compteur de quota ── */}
      {quota && !quota.illimite && (
        <div className={`tdb-quota-banner ${quotaAtteint ? 'tdb-quota-atteint' : ''}`}>
          <div className="tdb-quota-chiffres">
            <span className="tdb-quota-icone">{quotaAtteint ? '🔒' : '📄'}</span>
            <strong>Vos sites : {quota.utilise} sur {quota.limite}</strong>
          </div>
          <p className="tdb-quota-message">
            {quotaAtteint
              ? 'Une fois ce site réglé, vous pourrez en créer un nouveau.'
              : 'Vous pouvez créer votre site dès maintenant.'}
          </p>
        </div>
      )}

      <div className="tdb-section-header">
        <h2>📄 Mes sites</h2>
        <BoutonPrincipal
          quotaAtteint={quotaAtteint}
          quotaInconnu={quotaInconnu}
          siteARegler={siteARegler}
          libelleCreer="✨ Créer un nouveau site"
        />
      </div>

      {chargement && (
        <div className="tdb-chargement">
          <div className="tdb-spinner"></div>
          <p>Chargement de vos sites...</p>
        </div>
      )}

      {!chargement && sites.length === 0 && (
        <div className="tdb-empty">
          <div className="tdb-empty-icone">📄</div>
          <h3>Vous n'avez pas encore de site</h3>
          <p>Créez votre premier site professionnel en quelques minutes grâce à l'IA</p>
          <button
            type="button"
            className="tdb-btn-creer-empty"
            onClick={() => navigate('/creer-mon-site')}
            disabled={quotaInconnu}
          >
            🚀 Créer mon premier site
          </button>
        </div>
      )}

      {!chargement && sites.length > 0 && (
        <div className="tdb-sites-grid">
          {sites.map(site => <CarteSiteResume key={site.id} site={site} />)}
        </div>
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════
// CONTENU — COMPTE DEV / AGENCE
// ══════════════════════════════════════════════════════════════
function ContenuDev({ sites, chargement, quota, quotaAtteint, quotaInconnu, siteARegler, user }) {
  const navigate = useNavigate();

  const nomPlan = quota?.plan
    || (user?.plan_dev ? user.plan_dev.charAt(0).toUpperCase() + user.plan_dev.slice(1) : 'Essai');

  const messageForfait =
    `💼 DEMANDE FORFAIT DÉVELOPPEUR — PEFEP Site\n\n` +
    `Bonjour, je suis ${user?.nom || ''} ${user?.prenom || ''}.\n` +
    `Compte développeur : ${user?.email || ''}\n` +
    `Plan actuel : ${nomPlan}\n\n` +
    `J'aimerais des informations sur les forfaits développeur.\n\n` +
    `Merci !`;

  const lienForfait = `https://wa.me/50947376200?text=${encodeURIComponent(messageForfait)}`;

  return (
    <div className="tdb-contenu-dev">

      {/* ── Bandeau de plan ── */}
      <div className="tdb-dev-plan-banner">
        <div className="tdb-dev-plan-badge">💼 COMPTE DEV / AGENCE</div>

        <div className="tdb-dev-plan-info">
          <strong>Plan actuel : {nomPlan}</strong>
          {quota && !quota.illimite ? (
            <span>
              {quota.utilise} projet{quota.utilise > 1 ? 's' : ''} sur {quota.limite} —{' '}
              {quota.restant > 0
                ? `il vous reste ${quota.restant} projet${quota.restant > 1 ? 's' : ''}`
                : 'quota atteint'}
            </span>
          ) : (
            <span>{quota ? 'Projets illimités' : 'Chargement de votre forfait…'}</span>
          )}
        </div>

        <div className="tdb-dev-plan-actions">
          <button type="button" className="tdb-dev-btn-upgrade" onClick={() => navigate('/tarifs')}>
            🚀 Changer de forfait
          </button>
          <a
            href={lienForfait}
            target="_blank"
            rel="noopener noreferrer"
            className="tdb-dev-btn-whatsapp"
          >
            💬 Parler à un responsable
          </a>
        </div>
      </div>

      <div className="tdb-section-header">
        <h2>💼 Sites de mes clients</h2>
        <BoutonPrincipal
          quotaAtteint={quotaAtteint}
          quotaInconnu={quotaInconnu}
          siteARegler={siteARegler}
          libelleCreer="✨ Créer un site pour un client"
        />
      </div>

      {chargement && (
        <div className="tdb-chargement">
          <div className="tdb-spinner"></div>
          <p>Chargement de vos sites clients...</p>
        </div>
      )}

      {!chargement && sites.length === 0 && (
        <div className="tdb-empty">
          <div className="tdb-empty-icone">💼</div>
          <h3>Aucun site client pour le moment</h3>
          <p>Créez votre premier site client et commencez à générer des revenus</p>
          <button
            type="button"
            className="tdb-btn-creer-empty"
            onClick={() => navigate('/creer-mon-site')}
            disabled={quotaInconnu}
          >
            🚀 Créer le premier site client
          </button>
        </div>
      )}

      {!chargement && sites.length > 0 && (
        <div className="tdb-sites-grid">
          {sites.map(site => <CarteSiteResume key={site.id} site={site} />)}
        </div>
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════
// CARTE D'UN SITE
// Boutons : Voir / Gérer / Payer / Télécharger
// ══════════════════════════════════════════════════════════════
// ══════════════════════════════════════════════════════════════
// Calcule l'état d'expiration d'un site publié.
// Règle : 1 an jour pour jour depuis la publication, puis 15 jours
// d'alerte jaune, puis 15 jours d'alerte rouge (30 j de grâce au
// total). Après, le site n'est plus en ligne.
// ══════════════════════════════════════════════════════════════
function infoExpiration(site) {
  // Base de calcul : date_expiration si fournie, sinon publie_at + 1 an
  let expiration = null;
  if (site.date_expiration) {
    expiration = new Date(site.date_expiration);
  } else if (site.publie_at) {
    expiration = new Date(site.publie_at);
    expiration.setFullYear(expiration.getFullYear() + 1);
  }
  if (!expiration || isNaN(expiration.getTime())) return null;

  const maintenant = new Date();
  const unJour = 1000 * 60 * 60 * 24;
  const joursRestants = Math.ceil((expiration - maintenant) / unJour);

  const dateTexte = expiration.toLocaleDateString('fr-FR', {
    day: '2-digit', month: 'long', year: 'numeric',
  });

  // joursRestants > 0  : encore valide
  // -15 à 0            : alerte jaune (grâce 1)
  // -30 à -15          : alerte rouge (grâce 2)
  // < -30              : hors ligne
  if (joursRestants > 15) {
    return { niveau: 'ok', couleur: '#10B981', dateTexte, joursRestants,
      message: 'Actif — expire le ' + dateTexte };
  }
  if (joursRestants > 0) {
    return { niveau: 'bientot', couleur: '#F59E0B', dateTexte, joursRestants,
      message: 'Expire bientôt (' + joursRestants + ' j) — le ' + dateTexte };
  }
  if (joursRestants > -15) {
    return { niveau: 'jaune', couleur: '#F59E0B', dateTexte, joursRestants,
      message: 'Expiré le ' + dateTexte + ' — renouvelez sous ' + (15 + joursRestants) + ' j' };
  }
  if (joursRestants > -30) {
    return { niveau: 'rouge', couleur: '#EF4444', dateTexte, joursRestants,
      message: 'Dernier délai ! Plus que ' + (30 + joursRestants) + ' j avant coupure' };
  }
  return { niveau: 'hors', couleur: '#991B1B', dateTexte, joursRestants,
    message: 'Site hors ligne depuis le ' + dateTexte };
}

function CarteSiteResume({ site }) {
  const navigate = useNavigate();
  const [telechargement, setTelechargement] = useState(false);
  const [messageVerrou, setMessageVerrou] = useState('');
  const [copie, setCopie] = useState(false);

  const photoHero = site.photos_json?.hero || null;
  const icone = SECTEURS_ICONES[site.secteur] || '📄';
  const statut = STATUTS_INFO[site.statut] || STATUTS_INFO.brouillon;
  const telechargeable = STATUTS_TELECHARGEABLES.includes(site.statut);
  const estPublie = site.statut === 'publie';

  // ── Adresse du site ──
  const domainePerso = site.domaine_personnalise || '';
  const sousDomaine = site.sous_domaine || '';
  const adresse = domainePerso
    ? domainePerso
    : (sousDomaine ? sousDomaine + '.pefep.site' : '');
  const urlSite = adresse
    ? (adresse.startsWith('http') ? adresse : 'https://' + adresse)
    : '';

  const expiration = estPublie ? infoExpiration(site) : null;

  const dateCreation = new Date(site.created_at).toLocaleDateString('fr-FR', {
    day: '2-digit', month: 'short', year: 'numeric',
  });

  const handleTelecharger = async () => {
    if (!telechargeable) {
      setMessageVerrou('Le téléchargement est disponible une fois votre site réglé.');
      setTimeout(() => setMessageVerrou(''), 4000);
      return;
    }
    setTelechargement(true);
    const resultat = await telechargerFichier(
      `/api/exporter-site/${site.id}`,
      `${site.nom_organisation || 'mon-site'}.html`
    );
    if (!resultat.succes) {
      setMessageVerrou(resultat.erreur || 'Téléchargement impossible.');
      setTimeout(() => setMessageVerrou(''), 5000);
    }
    setTelechargement(false);
  };

  const ouvrirEnLigne = () => {
    if (urlSite) window.open(urlSite, '_blank', 'noopener,noreferrer');
  };

  const copierLien = () => {
    if (!urlSite) return;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(urlSite).then(() => {
        setCopie(true);
        setTimeout(() => setCopie(false), 2000);
      });
    }
  };

  const partagerWhatsApp = () => {
    if (!urlSite) return;
    const texte = encodeURIComponent(
      'Découvrez mon site : ' + urlSite
    );
    window.open('https://wa.me/?text=' + texte, '_blank', 'noopener,noreferrer');
  };

  const acheterDomaine = () => {
    navigate('/domaines');
  };

  return (
    <div className="tdb-site-card">

      <div className="tdb-site-photo">
        {photoHero
          ? <img src={photoHero} alt={site.nom_organisation} />
          : <div className="tdb-site-photo-placeholder"><span>{icone}</span></div>}
        <div className="tdb-site-statut" style={{ background: statut.couleur }}>
          {statut.icone} {statut.label}
        </div>
      </div>

      <div className="tdb-site-info">
        <div className="tdb-site-secteur">{icone} {site.secteur}</div>
        <h3>{site.nom_organisation}</h3>
        {site.ville && <p className="tdb-site-ville">📍 {site.ville}</p>}
        <p className="tdb-site-date">Créé le {dateCreation}</p>

        {estPublie && adresse && (
          <div className="tdb-domaine-bloc">
            <div className="tdb-domaine-ligne">
              <span className="tdb-domaine-label">
                {domainePerso ? '🌐 Votre domaine' : '🌐 Votre adresse'}
              </span>
              <span className="tdb-domaine-valeur">{adresse}</span>
            </div>

            <div className="tdb-domaine-partage">
              <button type="button" className="tdb-mini-btn" onClick={copierLien}>
                {copie ? '✅ Copié' : '📋 Copier le lien'}
              </button>
              <button type="button" className="tdb-mini-btn" onClick={partagerWhatsApp}>
                📲 Partager
              </button>
            </div>

            {!domainePerso && (
              <button type="button" className="tdb-domaine-upsell" onClick={acheterDomaine}>
                ✨ Obtenez un domaine personnalisé à votre nom
              </button>
            )}

            {expiration && (
              <div className="tdb-expiration" style={{ borderColor: expiration.couleur }}>
                <span className="tdb-expiration-point" style={{ background: expiration.couleur }}></span>
                <span style={{ color: expiration.couleur }}>{expiration.message}</span>
              </div>
            )}
          </div>
        )}

        <div className="tdb-site-actions">
          {estPublie && urlSite && (
            <button
              type="button"
              className="tdb-site-btn tdb-site-btn-enligne"
              onClick={ouvrirEnLigne}
            >
              🌐 Voir en ligne
            </button>
          )}

          <button
            type="button"
            className="tdb-site-btn tdb-site-btn-primary"
            onClick={() => navigate(`/mes-sites/${site.id}`)}
          >
            👁 Aperçu
          </button>

          <button
            type="button"
            className="tdb-site-btn tdb-site-btn-secondary"
            onClick={() => navigate(`/mes-sites/${site.id}/editer`)}
          >
            ✏ Gérer
          </button>

          {!telechargeable && site.statut !== 'archive' && (
            <button
              type="button"
              className="tdb-site-btn tdb-site-btn-paiement"
              onClick={() => navigate(`/mes-sites/${site.id}?scroll=paiement`)}
            >
              💳 Payer
            </button>
          )}

          <button
            type="button"
            className={`tdb-site-btn tdb-site-btn-telecharger ${telechargeable ? '' : 'tdb-site-btn-verrouille'}`}
            onClick={handleTelecharger}
            disabled={telechargement}
            title={telechargeable
              ? 'Télécharger le fichier HTML de votre site'
              : 'Disponible une fois votre site réglé'}
          >
            {telechargement ? '⏳ Préparation…' : telechargeable ? '⬇ Télécharger' : '🔒 Télécharger'}
          </button>
        </div>

        {messageVerrou && <p className="tdb-site-verrou-message">{messageVerrou}</p>}
      </div>
    </div>
  );
}